import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, createElementVNode as _createElementVNode, TransitionGroup as _TransitionGroup, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fb9f149"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "rBtn"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("管理")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("批量删除")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_6 = {
  key: 0,
  class: "el-upload__tip"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "item_r" }
const _hoisted_9 = { class: "item_r_info" }
const _hoisted_10 = { class: "item_r_btn" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("请上传文件")
const _hoisted_12 = { class: "numberOf" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_success_filled = _resolveComponent("success-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_circle_check = _resolveComponent("circle-check")!
  const _component_ImgBox = _resolveComponent("ImgBox")!
  const _component_folder_opened = _resolveComponent("folder-opened")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, {
    shadow: "never",
    style: _normalizeStyle({ width: _ctx.uploadWidth + 'px', border: _ctx.ifBorder ? '' : 0 })
  }, {
    default: _withCtx(() => [
      (_ctx.fileList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!_ctx.ifEdit)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ifEdit = true)),
                  type: "primary",
                  size: "mini",
                  icon: "Edit"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.selectedList.length > 0)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "danger",
                        size: "mini",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.del()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "mini",
                    onClick: _ctx.cancelEdit
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_upload, {
        class: "upload-demo",
        action: _ctx.action,
        headers: _ctx.headers,
        multiple: _ctx.ifMultiple,
        accept: _ctx.ifImage ? 'image/*' : '',
        "before-upload": _ctx.beforeAvatarUpload,
        "on-success": _ctx.handleAvatarSuccess,
        "on-error": _ctx.onError,
        limit: _ctx.maxCount,
        "on-exceed": _ctx.handleExceed,
        "file-list": _ctx.fileList,
        "show-file-list": false
      }, {
        tip: _withCtx(() => [
          (_ctx.ifPromptWords)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.promptWords || `支持扩展名：.rar .zip .doc .docx .pdf .jpg... 文件不能超过 ${_ctx.requireSize}MB`), 1))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          (_ctx.fileList.length < _ctx.maxCount)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                size: "small",
                type: "primary",
                icon: "UploadFilled"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["action", "headers", "multiple", "accept", "before-upload", "on-success", "on-error", "limit", "on-exceed", "file-list"]),
      _createElementVNode("div", {
        class: "uploadList",
        style: _normalizeStyle({ 'max-height': _ctx.uploadMaxHeight + 'px' })
      }, [
        (_ctx.fileList.length > 0)
          ? (_openBlock(), _createBlock(_TransitionGroup, {
              key: 0,
              tag: "div",
              name: "el-list"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "item",
                    key: item.localUrl
                  }, [
                    (_ctx.ifEdit)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "item_l",
                          onClick: ($event: any) => (_ctx.onSelected(item))
                        }, [
                          (_ctx.ifSelected(item))
                            ? (_openBlock(), _createBlock(_component_el_icon, {
                                key: 0,
                                color: "#5fadff"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_success_filled)
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_el_icon, {
                                key: 1,
                                color: "#999"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_circle_check)
                                ]),
                                _: 1
                              }))
                        ], 8, _hoisted_7))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        (_ctx.ifImageType(item))
                          ? (_openBlock(), _createBlock(_component_ImgBox, {
                              key: 0,
                              style: {"flex-shrink":"0"},
                              fit: "contain",
                              src: item.localUrl,
                              width: 70,
                              height: 70
                            }, null, 8, ["src"]))
                          : (_openBlock(), _createBlock(_component_el_icon, {
                              key: 1,
                              class: "folderIcon",
                              onClick: ($event: any) => (_ctx.showFolder(item.localUrl))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_folder_opened)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])),
                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        (_ctx.listSorting)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_el_tooltip, {
                                effect: "dark",
                                content: "上移",
                                placement: "top-start"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    icon: "CaretTop",
                                    circle: "",
                                    size: "small",
                                    onClick: ($event: any) => (_ctx.upGo(i)),
                                    disabled: i === 0
                                  }, null, 8, ["onClick", "disabled"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_tooltip, {
                                effect: "dark",
                                content: "下移",
                                placement: "top-start"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    icon: "CaretBottom",
                                    circle: "",
                                    size: "small",
                                    onClick: ($event: any) => (_ctx.downGo(i)),
                                    disabled: i === _ctx.fileList.length - 1
                                  }, null, 8, ["onClick", "disabled"])
                                ]),
                                _: 2
                              }, 1024)
                            ], 64))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_button, {
                          type: "danger",
                          icon: "DeleteFilled",
                          circle: "",
                          size: "small",
                          onClick: ($event: any) => (_ctx.del(i)),
                          style: {"margin-left":"20px"}
                        }, null, 8, ["onClick"])
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_divider, { key: 1 }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }))
      ], 4),
      _createElementVNode("p", _hoisted_12, "文件个数: " + _toDisplayString(_ctx.fileList.length), 1)
    ]),
    _: 1
  }, 8, ["style"]))
}